import { createApp } from 'vue';
import dateFormat, { masks } from "dateformat";


export default {
    name: 'booking',
    _el: null,

    init() {
        const el = document.getElementById('bookingForm');

        if (el) {
            this.run(el);
        }
    },

    run (el)
    {
        const app  = createApp({
            delimiters: ['@{', '}'],

            data() {
                return {
                    arrival          : '',
                    departure        : '',
                    adults           : 2,
                    children         : 1,
                    rooms           : 1,
                }
            },

            created()
            {
                const today = new Date;
                const tomorrow = new Date(today);
                tomorrow.setDate(tomorrow.getDate() + 1);

                this.arrival = dateFormat(tomorrow, "yyyy-mm-dd");
            },

            computed :
            {
                actionUrl()
                {
                    // ?Arrival=2023-04-01&Departure=2023-04-05&NroOfRooms=1&NroOfAdults=2&NroOfChildren=2
                    const base = 'https://book.aaah.no/reserve/no/home?';

                    const queryArgs = {
                        Arrival : this.arrival,
                        Departure : this.departure,
                        NroOfRooms : this.rooms,
                        NroOfAdults : this.adults,
                        NroOfChildren : this.children,
                    };

                    const params = new URLSearchParams(queryArgs);

                    return base+params.toString();
                }
            },
        }).mount(el);

    }
}